/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Partner_Admin_Remove_User_DescriptionInputs */



/**
* | output |
* | --- |
* | "Remove {email} from this partner's portal. Their passkey and sessions will be deleted." |
*
* @param {Partner_Admin_Remove_User_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_remove_user_description = /** @type {((inputs: Partner_Admin_Remove_User_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Remove_User_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} aus dem Portal dieses Partners entfernen. Passkey und Sitzungen werden gelöscht.`)
	return /** @type {LocalizedString} */ (`Remove ${i?.email} from this partner's portal. Their passkey and sessions will be deleted.`)
});